module.exports = __webpack_public_path__ + "img/Steve.6e34f466.jpg";